import React from "react"

export const SearchIcon = ({ color }:  {color: string}) => {
  return (
    <svg
      width="19px"
      height="19px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>search</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Headers---1"
          transform="translate(-1167.000000, -85.000000)"
          fill={color}
          fillRule="nonzero"
        >
          <g id="header-1" transform="translate(56.000000, 68.000000)">
            <g id="search" transform="translate(1111.000000, 17.000000)">
              <path
                d="M3.50228571,3.50228571 C-1.16742857,8.17085714 -1.16742857,15.74 3.50228571,20.4085714 C7.92971429,24.836 14.96,25.0571429 19.6562857,21.0871429 L26.1574286,27.5882857 C26.5514,27.9833714 27.1953714,27.9833714 27.5882286,27.5882857 C27.9833143,27.1954286 27.9833143,26.5514571 27.5882286,26.1574857 L21.0870857,19.6563429 C25.0570857,14.9597714 24.8348,7.92977143 20.4085143,3.50234286 C15.7399429,-1.16737143 8.16965714,-1.16737143 3.50222857,3.50234286 M4.93302857,4.93314286 C8.80588571,1.06028571 15.1050286,1.06028571 18.9776,4.93314286 C22.5947429,8.55028571 22.8436,14.4431429 19.5423429,18.3505714 L18.9965714,18.9967714 L18.3503714,19.5425429 C14.4429429,22.8439714 8.55008571,22.5951143 4.93294286,18.9778 C1.06008571,15.1049429 1.06008571,8.8058 4.93294286,4.93322857"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
export const CloseIcon = ({ color }: {color: string}) => {
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 36 36"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>close</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="close"
          transform="translate(2.000000, 2.000000)"
          fill={color}
          fillRule="nonzero"
        >
          <path
            d="M30.8443703,-0.905894127 C31.4360926,-1.49758825 32.3954412,-1.49756542 32.9871353,-0.905843127 C33.5591063,-0.333844914 33.5781507,0.581679617 33.0442842,1.17655414 L32.9870843,1.23692184 L1.15652663,33.0659643 C0.564804343,33.6576585 -0.394544208,33.6576356 -0.986238331,33.0659133 C-1.55820932,32.4939151 -1.57725368,31.5783906 -1.04338723,30.9835161 L-0.986187331,30.9231484 L30.8443703,-0.905894127 Z"
            id="Path"
          ></path>
          <path
            d="M-0.986541363,-0.905843127 C-0.414570378,-1.47784134 0.500953246,-1.49692928 1.09585318,-0.96309115 L1.1562236,-0.905894127 L32.9867813,30.9231484 C33.5785036,31.5148425 33.5785264,32.4741911 32.9868323,33.0659133 C32.4148613,33.6379116 31.4993377,33.6569995 30.9044377,33.1231614 L30.8440673,33.0659643 L-0.986490363,1.23692184 C-1.57821265,0.645227714 -1.57823549,-0.314120838 -0.986541363,-0.905843127 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  )
}
